/**
 * Scroll Lock Utility
 *
 * Prevents all scrolling (touch, wheel, keyboard) on a target element,
 * document body, and html. Works across all platforms including iOS Safari.
 *
 * Usage:
 *   import scrollLock from 'utils/scrollLock';
 *
 *   scrollLock.lock(element);   // lock scrolling
 *   scrollLock.unlock(element); // restore scrolling
 */

let locked = false;

const preventScroll = (e) => {
  e.preventDefault();
};

const preventKeyScroll = (e) => {
  // Space, Page Up, Page Down, End, Home, Arrow keys
  const scrollKeys = [32, 33, 34, 35, 36, 37, 38, 39, 40];
  if (scrollKeys.indexOf(e.keyCode) > -1) {
    e.preventDefault();
  }
};

const lock = (element) => {
  if (locked) return;
  locked = true;

  // Lock body and html
  document.body.style.overflow = "hidden";
  document.documentElement.style.overflow = "hidden";

  // Lock target element
  if (element) {
    element.style.overflowY = "hidden";
    element.addEventListener("touchmove", preventScroll, { passive: false });
    element.addEventListener("wheel", preventScroll, { passive: false });
  }

  // Prevent keyboard scrolling
  window.addEventListener("keydown", preventKeyScroll, { passive: false });
};

const unlock = (element) => {
  if (!locked) return;
  locked = false;

  // Unlock body and html
  document.body.style.overflow = "";
  document.documentElement.style.overflow = "";

  // Unlock target element
  if (element) {
    element.style.overflowY = "";
    element.removeEventListener("touchmove", preventScroll);
    element.removeEventListener("wheel", preventScroll);
  }

  // Restore keyboard scrolling
  window.removeEventListener("keydown", preventKeyScroll);
};

export default { lock, unlock };
